import { gold } from "@ant-design/colors"
import { faArrowLeft, faInfoCircle, faTrash } from "@fortawesome/pro-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Button, Modal, Space, Typography } from "antd"

type Props = {
  isOpen: boolean
  onOk: () => void
  onClose: () => void
}

const { Text } = Typography

const RemoveRoleModal = ({ isOpen, onOk, onClose }: Props) => {
  return <Modal
    title={<Space><FontAwesomeIcon icon={faInfoCircle} color={gold.primary}/>Remove this role?</Space>}
    okText="Remove"
    cancelText="Cancel"
    open={isOpen}
    onCancel={onClose}
    footer={[
      <Space key="actions">
        <Button onClick={onClose} icon={<FontAwesomeIcon icon={faArrowLeft} />}>Cancel</Button>
        <Button danger onClick={onOk} icon={<FontAwesomeIcon icon={faTrash} />}>Remove Role</Button>
      </Space>
    ]}
  >
    <Text>This cannot be undone and will remove all permissions on this role and users will no longer have this role .</Text>
  </Modal>
}

export default RemoveRoleModal